import { styled } from "@mui/material";
import { useState } from "react";
import { ENV, TENANT } from "src/utils/enviromentValues";

const ImageContainer = styled('div', {
    shouldForwardProp: (prop) => prop !== 'tableDensity',
})(({ tableDensity }) => ({
    position: 'relative',
    width: '40px', // Initial size
    height: `${tableDensity - 5}px`,
    overflow: 'visible', // Allow the image to overflow its bounds on hover
    //background: 'linear-gradient(135deg, #f0f0f0 25%, #d3d3d3 25%, #d3d3d3 50%, #f0f0f0 50%, #f0f0f0 75%, #d3d3d3 75%, #d3d3d3 100%)',
    //background:"white",
    backgroundSize: '8px 8px',
}));

const StyledImage = styled('img', {
    shouldForwardProp: (prop) => prop !== 'tableDensity',
})(({ tableDensity }) => ({
    position: 'absolute',
    top: '50%', // Center vertically in container
    left: '50%', // Center horizontally in container
    maxHeight: `${tableDensity - 5}px`,
    maxWidth: '40px', // Initial size
    opacity: 0,
    transform: 'translate(-50%, -50%) scale(1)', // Center and don't scale initially
    transition: 'opacity 0.1s ease-in-out, transform 0.1s ease', // Transition transform and opacity
    '&:hover': {
        zIndex: 4,
        transform: 'translate(-50%, -50%) scale(7)', // Adjust scale factor based on desired final size
        
    },
}));

const MultiFormatImage = ({ imgId, baseUrl, tableDensity }) => {
    const formats = ['jpg', 'png', 'jpeg'];
    const [currentFormatIndex, setCurrentFormatIndex] = useState(0);

    const handleImageLoad = (event) => {
        event.target.style.opacity = 1; // Fade in the image when it loads
    };

    const handleImageError = () => {
        if (currentFormatIndex < formats.length - 1) {
            setCurrentFormatIndex(currentFormatIndex + 1); // Try the next format
        }
    };

    return (
        <ImageContainer tableDensity={tableDensity}>
            {currentFormatIndex < formats.length && (
                <StyledImage
                    src={`${baseUrl}.${formats[currentFormatIndex]}`}
                    alt=""
                    onLoad={handleImageLoad}
                    onError={handleImageError}
                    loading="lazy"
                    tableDensity={tableDensity}
                />
            )}
        </ImageContainer>
    );
};

export const ThumbnailCell = ({ params, tableDensity = 45 }) => {
    const imgId = params.row.ImageResourceId;
  
    if (imgId != null) {
      const baseUrl = getResourceImageBaseUrl(imgId);
      return <MultiFormatImage imgId={imgId} baseUrl={baseUrl} tableDensity={tableDensity} />;
    }
  
    return null;
  };
  
export default ThumbnailCell;

export const getResourceImageBaseUrl = (imgId: any) => {
    if (imgId == null) return "";
    return `https://dacsaimagestorage.blob.core.windows.net/${TENANT}-${ENV}/raw/${imgId}`;
  };